import { useTranslation } from '@msdk/common'
import { Entity, FormViewDefinition } from '@msdk/definitions'
import { CardTable, Pagination, TableWrapper } from '@msdk/ui'
import React from 'react'

import { useEmbeddedView, useFormModal } from '../../hooks'
import { filtersToObject } from '../../utils'
import { DynamicView } from '../DynamicView'
import { DynamicViewProvider } from '../DynamicView/context'

interface Props {
  entityName: string
  viewName: string
  containerEntity: Entity
  viewDef: FormViewDefinition
}

export function DetailView(props: Props) {
  const { createModal: createFormModal } = useFormModal()
  const t = useTranslation()

  const {
    entityModel,
    viewModel,
    isLoading,
    response,
    currentPage,
    acl,
    fetchData,
    onPageChange,
    onOrderChange,
    reload,
    addColumnFilter,
    removeColumnFilter,
    removeAllColumnFilter,
    additionalCondition,
    currentOrder,
    addOrUpdateFilter,
  } = useEmbeddedView(
    props.entityName,
    props.viewName,
    props.containerEntity,
    filtersToObject(props.viewDef.viewFilterFields, props.containerEntity),
    props.viewDef.pageSize,
  )

  const onRowClicked = (row: Entity) => {
    const modalRef = createFormModal(entityModel.name, entityModel.defaultForm, row.id, () => {
      fetchData()
    })
    modalRef.open()
  }

  const onRowClickedFactory = () => (props.viewDef.canEdit ? onRowClicked : undefined)

  return (
    <>
      {viewModel && (
        <CardTable>
          <TableWrapper>
            <DynamicViewProvider
              entityModel={entityModel}
              viewModel={viewModel}
              reload={reload}
              rows={response?.source || []}
              isLoading={isLoading}
              onRowClick={onRowClickedFactory()}
              onOrderChange={onOrderChange}
              styleMode="Compact"
              acl={acl}
              addColumnFilter={addColumnFilter}
              removeColumnFilter={removeColumnFilter}
              removeAllColumnFilter={removeAllColumnFilter}
              additionalCondition={additionalCondition}
              currentFilters={filtersToObject(props.viewDef.viewFilterFields, props.containerEntity)}
              currentOrder={currentOrder}
              addOrUpdateFilter={addOrUpdateFilter}
            >
              <DynamicView />
            </DynamicViewProvider>
          </TableWrapper>
          {!viewModel.hidePagination && (
            <Pagination
              count={response?.totalItems ?? 0}
              page={currentPage}
              rowsPerPage={response?.pageSize ?? 30}
              rowsPerPageOptions={[]}
              onPageChange={(_e, page) => onPageChange(page)}
              labelDisplayedRows={({ from, to, count }) => `${from}-${to} ${t('CMPSR_PAGINATOR_OF', 'of')} ${count}`}
            />
          )}
        </CardTable>
      )}
    </>
  )
}
